import React, { FC } from 'react';

import { Box, Button } from '@rover/kibble/core';
import type { ServiceBenefitsImageSrcSet } from '@rover/react-lib/src/pages/landing/components/ServiceBenefits';
import ServiceBenefits from '@rover/react-lib/src/pages/landing/components/ServiceBenefits';
import type { ServiceBenefitItem } from '@rover/rsdk/src/apiClient/latest/model/serviceBenefitItem';

import whyChooseGroomerImage from '../images/why-choose-groomer.jpg';

const GROOMING_SEARCH_PATH = '/grooming/search/';

const serviceBenefitsImageSrcSet: ServiceBenefitsImageSrcSet = {
  desktop: { src: whyChooseGroomerImage, width: 585, height: 390 },
  mobile: { src: whyChooseGroomerImage, width: 350, height: 233 },
};

type GroomingServiceBenefitsProps = {
  serviceBenefitsHeading: string;
  serviceBenefitItems: ServiceBenefitItem[];
};

const GroomingServiceBenefits: FC<GroomingServiceBenefitsProps> = ({
  serviceBenefitsHeading,
  serviceBenefitItems,
}) => {
  if (!serviceBenefitItems.length) return null;

  return (
    <ServiceBenefits
      title={serviceBenefitsHeading}
      headingVariant="heading"
      imageProps={{ sx: { borderRadius: '16px', objectFit: 'cover' } }}
      columnGap="10x"
      imageWidth="585px"
      background="primary"
      serviceBenefitsImageSrcSet={serviceBenefitsImageSrcSet}
    >
      <ServiceBenefits.List>
        {serviceBenefitItems.map((item) => (
          <ServiceBenefits.ListItem key={item.title} title={item.title} mb="0x">
            {item.description}
          </ServiceBenefits.ListItem>
        ))}
      </ServiceBenefits.List>
      <Box display="flex" justifyContent={['center', 'flex-start']}>
        <Button
          variant="primary"
          size="default"
          href={GROOMING_SEARCH_PATH}
          width="100%"
          maxWidth={['321px', '259px']}
        >
          Find a groomer
        </Button>
      </Box>
    </ServiceBenefits>
  );
};

export default GroomingServiceBenefits;
